import React from 'react';
import { FILE_MAX_SIZE, ORDER_TYPE } from 'common/constants/app.constants';

export const ADDRESS_TYPE_ENUM = {
  EXISTINGADDRESS: 'existingAddress',
  NEWADDRESS: 'newAddress'
};

export const addresses = [
  { id: ADDRESS_TYPE_ENUM.EXISTINGADDRESS, displayName: 'Existing Addresses', disabled: true },
  { id: ADDRESS_TYPE_ENUM.NEWADDRESS, displayName: 'New Address' }
];

export const DOCUMENT_TYPE_ENUM = {
  SEZ: 'SEZ',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  AUTHORIZED_SIGNATORY: 'AUTHORIZED_SIGNATORY'
};

export const formElement = { value: null, errors: [], touched: false };
export const optionsForExistingAddress = [
  { displayName: 'Same as Billing address', key: 'billingAddress' },
  { displayName: 'Same as Installation address', key: 'installationAddress' }
];

export const fileSchemaForGSTCertificate = {
  supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
  maxFileLimit: FILE_MAX_SIZE,
  documentNames: ['GST_CERTIFICATE'],
  documentType: DOCUMENT_TYPE_ENUM.SEZ
};
export const fileSchemaForGSTLOA = {
  supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
  maxFileLimit: FILE_MAX_SIZE,
  documentNames: ['GST_LOA_1', 'GST_LOA_2', 'GST_LOA_3'],
  documentType: DOCUMENT_TYPE_ENUM.SEZ
};
export const DefaultArrayPo = [
  {
    name: 'purchage.pdf',
    size: 341873,
    type: 'application/pdf'
  }
];
export const DefaultArrayGst = [
  {
    name: 'gstCerificate.pdf',
    size: 341873,
    type: 'application/pdf'
  }
];
export const DefaultArrayLOA = [
  {
    name: 'gstLoa.pdf',
    size: 341873,
    type: 'application/pdf'
  }
];

const SEND_EMAIL_HEADER_TEXT = 'Please select the email ID to get the order confirmation Link.';
const SEND_OTP_HEADER_TEXT = 'Please select the email ID to send the order confirmation OTP.';

export const getEmailHeaderText = (email, status, isOrderConfirmation, isOTPVisible, isOTPBtnEnabled) => {
  if (isOTPVisible) {
    return <p>To confirm the order, please enter the 4-digit OTP code sent to your email address {email}.</p>;
  } else if (isOrderConfirmation || isOTPBtnEnabled) {
    return SEND_OTP_HEADER_TEXT;
  } else if (status === ORDER_TYPE.ORDER_CONFIRMATION_PENDING) {
    const emailElement = <span style={{ fontWeight: 'bold' }}>{email}</span>;
    return <p>Order confirmation link has already been sent to {emailElement}. Please select the email ID to send the order confirmation OTP/Link again. </p>;
  }
  return SEND_EMAIL_HEADER_TEXT;
};
